import * as React from 'react';
import { compose } from 'recompose';
import { reduxForm } from 'redux-form';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { get } from 'lodash';
import Divider from 'material-ui/Divider';
import Button from '@inqool/uas-web-core/es/components/controls/Button';

import { Input, InputField, RemoteAutoCompleteField, RemoteAutoComplete, DateField, Date } from '@components/form';

import * as T from '@modules/events/_eventsTypes';

const enhance = compose<T.EventsFormProps, T.Outter & T.EventsFormProps>(
  reduxForm({
    form: 'module-events-correspondences'
  })
);

const View: React.SFC<T.Outter & T.EventsFormProps> = ({ handleSubmit, closeItem }) => (
  <div>
    <form className="layout" onSubmit={handleSubmit}>
      <Grid fluid={true}>
        <Row>
          <Col className="grid-system-margin" />
        </Row>

        <Row>
          <Col md={12}>
            <Row>
              <Col md={4}>
                <h4>Číslo</h4>
              </Col>
              <Col md={8}>
                <InputField component={Input} id="number" name="number" />
              </Col>
            </Row>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <Row>
              <Col md={4}>
                <h4>Datum odeslání</h4>
              </Col>
              <Col md={8}>
                <DateField component={Date} id="sendDate" dateOnly={false} name="sendDate" />
              </Col>
            </Row>
          </Col>
        </Row>

        {[
          {
            name: 'employee',
            label: 'Zaměstnanec',
            url: '/metropolis/api/hr/employees',
            labelFunction: o => get(o, 'fullName')
          },
          {
            name: 'office',
            label: 'Úřad',
            url: '/metropolis/api/ed/correspondence/offices'
          },
          {
            name: 'type',
            label: 'Typ korespondence',
            url: '/metropolis/api/ed/correspondence/types'
          }
        ].map(({ name, label, url, labelFunction = o => get(o, 'name') }) => (
          <Row key={name}>
            <Col md={12}>
              <Row>
                <Col md={4}>
                  <h4>{label}</h4>
                </Col>
                <Col md={8}>
                  <RemoteAutoCompleteField
                    component={RemoteAutoComplete}
                    id={name}
                    name={name}
                    url={url}
                    fullWidth={true}
                    labelFunction={labelFunction}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        ))}
        <Row>
          <Col className="grid-system-margin" />
        </Row>
      </Grid>

      <Divider />

      <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
      <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
    </form>
  </div>
);

export const EventsFormCorrespodencesForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormCorrespodencesForm.tsx